import { Box, Tooltip, Typography } from "@mui/material";
import { sidebarData } from "../../data/dashboard/sidebarData";
import useCurrentPath from "../hooks/useCurrentPath";
import { Link } from "react-router-dom";
import {
  CloseRounded,
  InfoOutlined,
  MoreHorizRounded,
} from "@mui/icons-material";
import { useNavigationContext } from "../../context/navigation/NavigationContext";
import {
  ListBox,
  ListDivider,
  ListItem,
  ListItemLabel,
  ListTitle,
} from "../../ui/ListStyles";
import { COLORS } from "../../ui/Theme";
import { useState } from "react";

const BottomNavigation = () => {
  const { isMobileNavigation, setIsMobileNavigation } = useNavigationContext();
  const [hoveredItem, setHoveredItem] = useState(null);

  const { route1, route2 } = useCurrentPath();

  let timeoutId;

  const handleMouseEnter = (id) => {
    clearTimeout(timeoutId);
    setHoveredItem(id);
  };
  const handleMouseLeave = () => {
    timeoutId = setTimeout(() => setHoveredItem(null), 250);
  };
  return (
    <Box
      sx={{
        zIndex: 1,
        position: "fixed",
        bottom: 0,
        width: "100vw",
        bgcolor: "#ffff",
        textAlign: "center",
        height: "64px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "16px 24px",
        border: "1px solid #eee",
      }}
    >
      {sidebarData.slice(0, 3).map((data) => (
        <Box
          key={data.id}
          onMouseEnter={() => handleMouseEnter(data.id)}
          onMouseLeave={handleMouseLeave}
          sx={{ position: "relative" }}
        >
          <Link to={data.link ? data.link : "#"}>
            <Box
              sx={{
                color: route1?.route === data.id ? "#2196F3" : "#9e9e9e",
                py: "10px",
                px: "12px",
                borderRadius: 3,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              {data.icon}
              <Typography fontSize={"14px"}>{data.title}</Typography>
            </Box>
          </Link>

          {data.items && hoveredItem === data.id && (
            <ListBox
              className="dropdown"
              sx={{
                position: "absolute",
                bottom: "110%",
                left: "50%",
                transform: "translateX(-50%)",
              }}
              onMouseEnter={() => clearTimeout(timeoutId)}
              onMouseLeave={handleMouseLeave}
            >
              <ListTitle>{data.title}</ListTitle>

              <ListDivider flexItem />

              {data.items.map((item, i) => (
                <Tooltip
                  key={i}
                  arrow
                  title={
                    item.desc && (
                      <Box
                        sx={{
                          display: "flex",
                          gap: 0.5,
                          flexWrap: "wrap",
                          alignItems: "center",
                        }}
                      >
                        <Typography fontSize={"11px"}>{item?.desc}</Typography>
                      </Box>
                    )
                  }
                  placement="left"
                >
                  <Link to={item.link}>
                    <ListItem
                      sx={{
                        background:
                          route2?.label === item.label && COLORS.SOFTBLUE,
                        color: route2?.label === item.label && COLORS.BLUE,
                      }}
                    >
                      <ListItemLabel>{item.label}</ListItemLabel>
                      {item.desc && <InfoOutlined fontSize="10px" />}
                    </ListItem>
                  </Link>
                </Tooltip>
              ))}
            </ListBox>
          )}
        </Box>
      ))}
      <Box
        onClick={() => setIsMobileNavigation((prev) => !prev)}
        sx={{
          color: "#9e9e9e",
          py: "10px",
          px: "12px",
          borderRadius: 3,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          cursor: "pointer",
        }}
      >
        {!isMobileNavigation ? (
          <>
            <MoreHorizRounded sx={{ fontSize: "24px" }} />
            بیشتر
          </>
        ) : (
          <>
            <CloseRounded sx={{ fontSize: "24px" }} />
            بستن
          </>
        )}
      </Box>
    </Box>
  );
};

export default BottomNavigation;
